import { ClaimPromoPayload, ClaimPromoResponse, HTTPResponse } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

class PromoController extends BaseApiService {

  public async claimPromo(data: ClaimPromoPayload): Promise<HTTPResponse<ClaimPromoResponse>> {
    const url = `${this.url}/api/promos/claim`;
    return await this.http.post(url, data, { skipInterceptor: true });
  }

}

export const promoController = new PromoController({ url: env.origin });
